// ══════════════════════════════════════════════════════════════════════════════
// COLLABS PRO PAGE - Page wrapper pour la collaboration avec externes
// Intègre CollabPage dans le layout du Cockpit Pro
// ══════════════════════════════════════════════════════════════════════════════

import React from 'react';
import CollabPage from '../../../components/collab/CollabPage';

export default function CollabsProPage() {
  return (
    <div className="h-full w-full overflow-hidden bg-slate-50">
      <CollabPage />
    </div>
  );
}
